export default {
  HomePage: {
    title: 'Hello',
    goodbye: 'Good bye',
  },
  EMAIL_CAMPAIGN_FOOTER: {
    UNSUBSCRIBE_TEXT: 'If you no longer wish to receive these emails, ',
    UNSUBSCRIBE_LINK: 'click here to unsubscribe',
  },
};
